import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_imagemaint } from "../shared/data.service";

import { SchoolInfo } from "../shared/SchoolInfo";
import { wsImageGroupInfo } from "../shared/wsImageGroupInfo";
import { wsImageLibraryListInfo } from "../shared/wsImageLibraryListInfo";
import { wsImageLibraryAssocGroupListInfo } from "../shared/wsImageLibraryAssocGroupListInfo";
import { wsImageLibraryAssocGroupListInfoParm } from "../shared/wsImageLibraryAssocGroupListInfoParm";
import { wsImageLibraryAssocGroupModifyInfoParm } from "../shared/wsImageLibraryAssocGroupModifyInfoParm";
import { wsImageLibraryAssocGroupModifyItemsInfo } from "../shared/wsImageLibraryAssocGroupModifyInfoParm";

import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./imageassociation.component.html",
	styleUrls: ["./imageassociation.component.css"],
})
export class ImageAssociationComponent implements OnInit, OnDestroy {
	constructor(private dataService: DataService_imagemaint, public ref: DynamicDialogRef, public dialogConfig: DynamicDialogConfig) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;
	public SelectedSchool: SchoolInfo;
	public SelectedGroup: wsImageGroupInfo;
	public SelectedImageLibraryItem: wsImageLibraryListInfo;
	public ImageLibraryAssocList: wsImageLibraryAssocGroupListInfo[] = [];

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.SelectedSchool = this.dialogConfig.data.SelectedSchool;
		this.SelectedGroup = this.dialogConfig.data.SelectedGroup;
		this.SelectedImageLibraryItem = this.dialogConfig.data.SelectedItem;

		let parms: wsImageLibraryAssocGroupListInfoParm = {
			ImageLibraryID: this.SelectedImageLibraryItem.ImageLibraryID,
			SchoolID: this.SelectedSchool.SchoolID,
			ImageLibraryGroupID: this.SelectedImageLibraryItem.ImageLibraryGroupID,
		};

		this.isBusy = true;
		this.dataService.ImageLibraryAssociationGroupSelectList(parms).subscribe((data) => this.ImageLibraryAssociationGroupSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibraryAssociationGroupSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibraryAssociationGroupSelectList_Complete(data: any) {
		this.isBusy = false;
		this.ImageLibraryAssocList = data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSave
	//
	//-----------------------------------------------------------------------------------------------------
	onSave() {
		let list: wsImageLibraryAssocGroupModifyItemsInfo[] = [];

		this.ImageLibraryAssocList.forEach((element) => {
			let item: wsImageLibraryAssocGroupModifyItemsInfo = {
				ImageLibraryAssociationID: element.ImageLibraryAssociationID,
				TableKey: element.TableKey,
				IsAssociated: element.IsAssociated,
			};

			list.push(item);
		});

		let parms: wsImageLibraryAssocGroupModifyInfoParm = {
			SchoolID: this.SelectedSchool.SchoolID,
			ImageLibraryGroupID: this.SelectedImageLibraryItem.ImageLibraryGroupID,
			ImageLibraryID: this.SelectedImageLibraryItem.ImageLibraryID,
			ItemList: list,
		};

		this.isBusy = true;
		this.dataService.ImageLibraryAssociationGroupModify(parms).subscribe((data) => this.ImageLibraryAssociationGroupModify_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibraryAssociationGroupSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibraryAssociationGroupModify_Complete(data: any) {
		this.isBusy = false;
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(1);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
